<template>
    <h1>Inhalt nicht gefunden</h1>
</template>

<script>
    export default {
        name: "Default"
    }
</script>

<style scoped>

</style>
